import { Pipe, PipeTransform } from '@angular/core';
import { coalesceFilter } from './data.functions';

@Pipe({
  name: 'coalesce'
})
export class CoalescePipe implements PipeTransform {
    transform(target, fieldName, defaultValue, splitterValue): string {
        return coalesceFilter(target, fieldName, defaultValue, splitterValue);
    }
};